import React from "react";
import { useGameState } from "context/GameContext";
// Comps
import { IonPage } from "@ionic/react";
import Container from "components/common/Container/Container";
import Logo from "components/common/Logo/Logo";
import Code from "components/pages/Game/WaitingRoom/Code/Code";
import Players from "components/pages/Game/WaitingRoom/Players/Players";
import Actions from "components/pages/Game/WaitingRoom/Actions/Actions";
// Css
import classes from "./WaitingRoom.module.scss";
// WebSocket
import { ws } from "api/webSocket";

const WaitingRoom: React.FC = () => {
  const { code } = useGameState();

  return (
    <IonPage>
      <Container
        className={classes.container}
        onBack={() => ws.leaveGame(code)}
      >
        <Logo maxWidth="150px" />
        <h2 className={classes.title}>WAITING ROOM</h2>
        <p className={classes.desc}>ask host to start the game!</p>
        <Code />
        <h2 className={classes.playersTitle}>players</h2>
        <Players />
        <Actions />
      </Container>
    </IonPage>
  );
};

export default WaitingRoom;
